export default __webpack_public_path__ + "static/media/warning--horizontal-alignment-left--g1.5f4578ae.png";